var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"inbox_grid",class:{
        'inbox_grid--single_column': _vm.isSingleColumn,
        'inbox_grid--overlay': _vm.isOverlay,
        'inbox_grid--is_rerendering_grid': _vm.isRerenderingGridInSafari,
    }},[_c('div',{staticClass:"inbox_grid__review"},[_c('header',{staticClass:"inbox_grid__review__header"},[_vm._t("header")],2),_c('main',{staticClass:"inbox_grid__review__main"},[_vm._t("main")],2)]),_c('aside',{staticClass:"inbox_grid__aside"},[_vm._t("aside")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }